import { MAPBOX_API_URL, MAPBOX_TOKEN } from "../config"
import { Coord } from "./map"

const reverseGeocodeCache: { [key: string]: string } = {}

export async function coordinatesToPlace(coords: Coord) {
  const lat = coords[0]
  const lng = coords[1]
  const key = lat.toString() + lng.toString()
  if (!reverseGeocodeCache[key]) {
    const result = await reverseGeocode(lat, lng)
    reverseGeocodeCache[key] = result
    return result
  } else {
    return reverseGeocodeCache[key]
  }
}

async function reverseGeocode(lat: number, lng: number) {
  try {
    const res = await fetch(
      MAPBOX_API_URL +
        `geocoding/v5/mapbox.places/${lat},${lng}.json` +
        `?access_token=${MAPBOX_TOKEN}` +
        "&type=address,place&limit=1",
    )
    if (res.status !== 200) {
      return `${lat}, ${lng}`
    }
    const val = await res.json()
    return val.features[0]?.place_name
  } catch {
    return `${lat}, ${lng}`
  }
}
